import React from 'react';

import { StyledBackgroundWrapper } from './PageBackgroundWrapper.styles';
import { ReactChildrenPropType } from '../../../lib/commonPropTypes';

function PageBackgroundWrapper(props) {
  const { children } = props;

  return <StyledBackgroundWrapper id="pageBackgroundWrapper">{children}</StyledBackgroundWrapper>;
}

PageBackgroundWrapper.propTypes = {
  children: ReactChildrenPropType.isRequired
};

export default PageBackgroundWrapper;
